import { updateVehicles, Vehicle } from './VehiclesHOC';

let socket: WebSocket|null = null;
let connected = false;
let reconnect_timeout = 1000;
let url = "";

let reconnect_timer: NodeJS.Timeout|null = null;

function connect(target_url: string) {
    if (reconnect_timer) {
        clearTimeout(reconnect_timer);
    }
    reconnect_timer = null;
    url = target_url;
    if (!url) {
        throw new Error("Cannot connect ws without supplying url.");
    }
    socket = new WebSocket(url);
    socket.addEventListener('open', (event) => {
        console.log("connected");
        connected = true;
        reconnect_timeout = 1000;
    });
    socket.addEventListener('close', (event) => {
        console.log("close");
        connected = false;
        reconnect();
    });

    socket.addEventListener('message', (msg) => {
        // console.log("NOTIFICATION >> ", msg.data);
        let payload: {
            type: string;
            data: Vehicle[];
        };
        try {
            payload = JSON.parse(msg.data);
        } catch (err) {
            //TODO: Silently send message to Slack!
            console.error(err);
            return;
        }
        if (payload.type === "liveunits_updated") {
            updateVehicles(payload.data);
        } else {
            console.error("Unknown socket message type.");
            //TODO: Sliently send message to Slack!
        }
    });

    socket.addEventListener('error', (err) => {
        console.error(err);
        //TODO: Silent msg to slack.
    });
}

function reconnect() {
    if (reconnect_timer) { return; }

    reconnect_timer = setTimeout(() => {
        connect(url);
    }, reconnect_timeout);
    if (reconnect_timeout < 15000) {
        reconnect_timeout *= 2;
    }
}

function isConnected() {
    return connected;
}

export default {
    connect: connect,
    isConnected: isConnected
};


// WEBPACK FOOTER //
// ./src/socket.ts